import { IPriceRelevance } from '../../types/newbuilding/priceRelevance';
import { TApplicationState } from '../../types/redux';
import { pathOr } from 'ramda';

export function getPriceRelevance(state: TApplicationState): IPriceRelevance | null {
  return pathOr(null, ['newbuilding', 'relevanceInfo'], state);
}
